import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'

import { displayMessages } from './common'

export function getUsuarios(page = 1) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const showRecords = getState().usuarios.get('showRecords')
		const orderBy = getState().usuarios.get('orderBy')
		const filters = getState().usuarios.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()

		axios.get(`${API_URL}/usuarios`, { params: { page, showRecords, orderBy, filters }})
		.then((res) => {
			const data = res.data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
			const totalRecords = Number(res.data.totalRecords)
			const fn1 = d => d({ type: types.OBTENER_USUARIOS, payload: { data, page, totalRecords } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}



export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.CAMBIAR_MOSTRAR_REGISTROS_USUARIOS, payload: showRecords })
        const fn1 = (d) => d(getUsuarios(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function toggleSelectItem(id, checked) {
	return (dispatch, getState) => {
		const index = getState().usuarios.get('usuarios').findIndex(x => x.get('id') === id)
		dispatch({ type: types.CONMUTAR_SELECCION_USUARIO, payload: { index, checked } })
	}
}

export function toggleSelectAllItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_USUARIOS, payload: checked })
	}
}

export function filterUsuarios(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_USUARIOS, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().usuarios.get('orderBy')
		current = current.set('field', field.value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}

        const fn0 = (d) => d({ type: types.ORDENAR_USUARIOS, payload: { orderBy: current } })
        const fn1 = (d) => d(getUsuarios(1))
        fn0(dispatch)
        fn1(dispatch)
	}
}

export function displayModalCreate(show, title, mode, id) {
	const axios = createAxiosInstance()

	return (dispatch) => {
		const fn0 = () => axios.get(`${API_URL}/usuarios/${id}`)
		const fn1 = () => axios.get(`${API_URL}/permisos`)
		const fn2 = () => axios.get(`${API_URL}/grupos`)
		const fn3 = () => axios.get(`${API_URL}/usuarios/areas`)

		if (id) {
			Promise.all([fn0(),fn1(),fn2(),fn3()])
			.then((res) => {
				const usuario = res[0].data.usuario
				usuario.permisos = res[1].data.map(x => {
					x.selected = usuario.permisos.filter(p => p.id === x.id).length === 1
					return x
				})
				usuario.grupos = res[2].data.data.map(x => {
					x.selected = usuario.grupos.filter(g => g.id === x.id).length === 1
					return x
				})
				const areas = res[3].data.data;
				
				dispatch({ type: types.MOSTRAR_MODAL_CREAR_USUARIO, payload: { show, title, mode, usuario, areas } })
			})
			.catch((err) => {
				displayMessages(dispatch, err)
			})
		} else {
			Promise.all([fn1(),fn2(), fn3()])
			.then((res) => {
				const permisos = res[0].data.map(x => {
					x.selected = false
					return x
				})
				const grupos = res[1].data.data.map(x => {
					x.selected = false
					return x
				})
				const areas = res[2].data.data;

				dispatch({ type: types.MOSTRAR_MODAL_CREAR_USUARIO, payload: { show, title, mode, permisos, grupos, areas } })
			})
			.catch((err) => {
				displayMessages(dispatch, err)
			})


			dispatch({ type: types.MOSTRAR_MODAL_CREAR_USUARIO, payload: { show, title, mode } })
		}
	}
}

export function updateInputsInModalCreate(attr, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS, payload: { attr, value } })
	}
}

export function createOrUpdateUsuarios(data, mode) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		if (getState().usuarios.getIn(['modalCreate','data','reporta_a','id']) === getState().common.getIn(['user','id'])) {
			displayMessages(dispatch, { warning: 'El usuario al que reporta no puede ser el mismo usuario' })
		} else {
			const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_USUARIOS, payload: true })
			const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_USUARIOS, payload: false })
			fn0(dispatch)

			data = data.set('grupos', data.get('grupos').filter(x => x.get('selected')).map(x => x.get('id')))
			data = data.set('permisos', data.get('permisos').filter(x => x.get('selected')).map(x => x.get('id')))

			if (mode === 'create') {
				axios.post(`${API_URL}/usuarios`, data.toJS())
					.then(res => {
						const usuario = res.data
						usuario.visible = true
						usuario.selected = false
						dispatch({ type: types.CREAR_ACTUALIZAR_USUARIO, payload: usuario })
						displayMessages(dispatch, { success: 'El usuario ha sido guardado exitosamente' })
						fn1(dispatch)
					})
					.catch(err => {
						console.log(err)
						displayMessages(dispatch, err)
						fn1(dispatch)
					})
			} else if (mode === 'edit') {
				axios.put(`${API_URL}/usuarios/${data.get('id')}`, data.toJS())
					.then(res => {
						const usuario = res.data
						usuario.visible = true
						usuario.selected = false
						dispatch({ type: types.CREAR_ACTUALIZAR_USUARIO, payload: usuario })
						displayMessages(dispatch, { success: 'El usuario ha sido actualizado exitosamente' })
						fn1(dispatch)
					})
					.catch(err => {
						console.log(err)
						displayMessages(dispatch, err)
						fn1(dispatch)
					})
			}
		}
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO, payload: { open, message, action } })
	}
}

export function deleteUsuarios() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().usuarios.get('usuarios').filter(x => x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/usuarios/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.Nombre)
					dispatch({ type: types.ELIMINAR_USUARIO, payload: x.result.data.id })
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes usuarios: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})
	}
}

export function showHideModalFilter(state) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS, payload: state })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_USUARIOS })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_USUARIOS })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_USUARIOS, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_USUARIOS })
        const fn1= (d) => d(getUsuarios(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function updateInputs(path, value, immutable = true) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_USUARIOS, payload: { path, value, immutable } })
		fn1(dispatch)
	}
}


// WEBPACK FOOTER //
// ./src/actions/usuarios.js